// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__Mz255","spinner":"Spinner_spinner__rf06H","spinnerAnim":"Spinner_spinnerAnim__FeCBQ","sm":"Spinner_sm__sOgzj","centered":"Spinner_centered__6pRSx"};